<template>
  <div class="settings main-body-right">
    <div
      v-if="isAccountActive"
      class="wrap"
    >
      <div class="system">
        Analytics
      </div>
      <div class="nav sub-nav">
        <router-link
          to="/analytics/overview"
          tag="div"
          class="router"
          :activeClass="'active'"
          :event="moving"
        >
          Overview
        </router-link>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Analytics',
  computed: {
    ...mapGetters([
      'isAccountActive',
    ]),
    moving() {
      return this.isAccountActive ? 'click' : '';
    },
  },
};
</script>

<style scoped>
  .main-body-right {
    display: flex !important;
    padding: 0;
  }

  .nav {
    background: transparent;
    display: flex;
    flex-direction: column;
    padding: 25px;
  }

  .system {
    border-bottom: 1px solid #383b40;
    padding: 30px 0 25px 25px;
  }

  .wrap {
    border-right: 1px solid #383b40;
    flex-direction: column;
    min-width: 330px;
  }

  .router {
    cursor: pointer;
    display: inline-block;
    margin-bottom: 35px;
    width: fit-content;
  }

  .router:hover {
    color: #2591cf;
  }

  .active {
    color: #2591cf;
  }

  @media all and (max-width: 1200px) {
    .wrap {
      display: none;
    }
  }
</style>
